module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE4AAABQCAYAAAC3dkP2AAAA8klEQVR4nO3cQQ6CQBAAQTA+i98v/8Kr4q2ThWiqPgDpzBLgMOsY41jebNu2LnzZ9/2j0+OuG/l1wkXCRcJFwkXCRcJFwkXCRc/ZFzi/cV9l9heQiYuEi6Yf1ZPZPxAueyyYuEi4SLhIuEi4SLhIuEi4SLhIuEi4SLhIuEi4SLhIuEi4SLhIuEi4SLhIuEi4SLhIuEi4SLhIuEi4SLhIuEi4SLhIuEi4SLhIuEi4SLhIuEi4SLhIuEi4SLhIuEi4SLhIuEi4SLhIuEi46OotELcsb5nBxEXCRdOP6r9ueTVxkXCRcJFwkXCRcJFwkXCRcNELX0EOpOyxfqAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/editor/icon/MeanTrue.png
// module id = NTUa
// module chunks = 3